import { PlusIcon } from '@heroicons/react/outline';
import { Link } from 'react-router-dom';
import { useLegalEntityRegions } from '../../../../hooks/useUser';

export const AddLocationLink = () => {
  const regions = useLegalEntityRegions();

  if (regions.length < 51) {
    return (
      <li data-static-list-item="true">
        <Link
          to="/locations/usa/setup"
          className="flex shrink-0 grow items-center justify-center gap-x-2 rounded border border-teal-350 px-3 py-2 text-sm font-medium leading-6 text-teal-900 outline-none focus-visible:ring-2 focus-visible:ring-teal-800"
        >
          <PlusIcon className="size-4 shrink-0" />
          <div className="shrink-0 grow text-nowrap">Add location</div>
        </Link>
      </li>
    );
  }

  return null;
};
